<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="370">
    <v-card >
        <v-card-text class="pa-4 subtitle-1" v-if="auth==false">
          <v-form autocomplete="off">
           <v-text-field
            v-model="text"
            class="lg-font"
            style="font-size: 20px; text-align: center;"
            type="number"
            label="Convert commission"
            hide-details
            outlined
            large
           />
          </v-form>
          <div class="tex-center mt-3 mb-3">
            
               <!-- <v-row no-gutters>
                    <v-col class="pa-1">
                        <v-btn tile block @click="text='1000', ValidateSender()">1,000</v-btn>
                    </v-col>
                      <v-col class="pa-1">
                      <v-btn tile block @click="text='5000',ValidateSender()">5,000</v-btn>
                    </v-col>
                      <v-col class="pa-1">
                       <v-btn tile block  @click="text='10000',ValidateSender()">10,000</v-btn>
                    </v-col>
                    <v-col class="pa-1">
                       <v-btn tile block @click="text='20000',ValidateSender()">20,000</v-btn>
                    </v-col>
                      <v-col class="pa-1">
                       <v-btn tile block  @click="text='30000',ValidateSender()">30,000</v-btn>
                    </v-col>
                    <v-col class="pa-1">
                       <v-btn tile block @click="text='50000',ValidateSender()">50,000</v-btn>
                    </v-col>
           </v-row> -->
          </div>
          <v-divider/>
        </v-card-text>
          <v-card-text class="pa-4 text-center" v-else>
                  <div class="lg-font mb-3"> Convert  <span class="text-h5 text-success">{{$money(text)}}</span> to points</div>
                  
            <v-divider/>
          </v-card-text>
        <v-card-actions>
                <v-btn color="warning"  text   @click="text ='close', emitToParent()">close</v-btn>
            <v-spacer></v-spacer>
             <v-btn large  color="success" :loading="loading" @click="validateAmount()" v-if="auth==true">
              <v-icon left   v-if="sendbtn=='SEND' || sendbtn=='Points sent'">mdi-{{icon}}</v-icon> 
                <!-- <v-progress-circular
                :rotate="360"
                :size="38"
                :width="5"
                v-if="sendbtn=='Cancel sending'"
                class="mr-2"
                :value="value"
                color="#fefefe"
                >
                </v-progress-circular> -->
                <template v-if="sendbtn=='convert'">
                  Confirm and
                </template>
              {{sendbtn}}</v-btn>
            <v-btn large  color="success"  @click="ValidateSender()" v-else>
              <v-icon left   v-if="sendbtn=='SEND' || sendbtn=='Points sent'">mdi-{{icon}}</v-icon>convert</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    data: () => ({
        text: '',
        sendbtn:"convert",
         interval: {},
         loading: false,
         value:0,
         auth: false,
    }),
  props: {
    show: {
        type: Boolean,
        default: false
    },
    account: {
       type: Object,
        default: ()=>{}
    } 
  },
  watch:{
      show(val) {
          if(!val){
            this.text=''
            this.sendbtn = "SEND"
             this.auth=false
             this.loading = false
             clearInterval(this.interval)
        }
      }
  },
  computed:{
      icon() {
         switch(this.sendbtn) {
           case "SEND":
             return "database-arrow-right"
          case "Points sent":
             return "check"
          default: 
            return ""
         }
      }
  },
  methods: {
    ValidateSender(){
         if(this.$IsNum(this.text.trim())) {
            this.auth = true
      } else {
        this.VA_ALERT('error', "Enter points!")
      }
    },
    validateAmount(){
      if(this.$IsNum(this.text.trim())) {
              this.sendbtn = "Cancel sending"
              this.loading = true
              this.Send()
              // this.interval = setInterval(() => {
              //       if (this.value === 100) {
              //         this.value = 0
              //         clearInterval(this.interval)
              //          this.sendbtn = "Points sent"
              //         //this.emitToParent()
              //         return 
              //       }
              //       this.value += 5
              //     }, 400)
      } else {
        this.VA_ALERT('error', "Enter points!")
      }
    },
    Send() {
        var param = {}
          param.type = "Commission to load"
        param.description = "Convert commision to load"
        param.amount = this.$IsNum(this.text.trim())
        param.account = this.account.id
       console.log(param)
        this.$http.post("wallet/load",param).then(response => {
              if(response.data.status) {
                  this.VA_ALERT('success', response.data.message)
                  
                  this.emitToParent()
              } else {
                  this.VA_ALERT('error', response.data.message)
              }
              this.loading = false
          }).catch(e => {
            console.log(e.data)
          })

    },

    emitToParent () {
      this.$emit('DialogEvent', this.text.trim())
    }
  }
}
</script>
